/**
 * Checks if eyeable is available on the window object
 * eyeable is loaded via official script tags in index.html
 * @returns true if eyeable API is available
 */
export function getEyeAbleDomain(): boolean {
  if (typeof window === "undefined") return false;
  
  // eyeable makes the EyeAbleAPI available on window
  return typeof window.EyeAbleAPI !== "undefined";
}
